import { render, staticRenderFns } from "./PurchasePlanForm.vue?vue&type=template&id=6ba71e2d"
import script from "./PurchasePlanForm.vue?vue&type=script&lang=js"
export * from "./PurchasePlanForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports